// Preferences remain usable for this page when browser storage is denied/full.
const memory = new Map();
export function readStorage(key) {
  if (memory.has(key)) return memory.get(key);
  try {
    const value = globalThis.localStorage.getItem(key);
    memory.set(key, value);
    return value;
  } catch { return null; }
}
export function writeStorage(key, value) {
  memory.set(key, String(value));
  try { globalThis.localStorage.setItem(key, String(value)); } catch { /* session fallback */ }
}
export function removeStorage(key) {
  memory.set(key, null);
  try { globalThis.localStorage.removeItem(key); } catch { /* session fallback */ }
}
